import {EfeResponse, Layout, RegisterServiceValues, ScreenFilterValues, View} from 'commons/models';
import EfeApi from 'services/api/Api';

/**
 * Get Layout by ID
 * @returns {any}
 */
async function getLayout(id: number): Promise<EfeResponse<Layout>> {
    try {
        return await EfeApi.Layouts.get<Layout>(`/api/v1/configurations/${id}`).then(function (
            res
        ) {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function getLayoutByPersonType(values: RegisterServiceValues): Promise<EfeResponse<Layout>> {
    try {
        return await EfeApi.Layouts.get<Layout>('/api/v1/configurations', {
            params: values,
        }).then(function (response) {
            return Promise.resolve({
                data: response.data,
                status: 'Success',
                success: true,
                code: response.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function getViewByFilters(values: ScreenFilterValues): Promise<EfeResponse<View>> {
    try {
        return await EfeApi.Layouts.get<View>('/api/v1/configurations/screens', {
            params: values,
        }).then(function (response) {
            return Promise.resolve({
                data: response.data,
                status: 'Success',
                success: true,
                code: response.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

export default {
    getLayout,
    getViewByFilters,
    getLayoutByPersonType,
};
